const mutations = {
  SET(state, payload) {
    state.isVisible = payload.isVisible
  },
}

export default mutations
